export default __webpack_public_path__ + "static/media/330_business02-it-mobile.3ad71673.png";